/**
 * 种子随机源 — mulberry32，32 位状态、完全可序列化。
 * 状态仅为一个 uint32，可随存档保存/恢复，保证同种子同序列。
 * 禁止使用 Math.random / Date.now / performance.now。
 */

/** 可序列化的 RNG 状态。 */
export interface RngState {
  readonly seed: number;
}

export class SeededRng {
  private state: number;

  private constructor(state: number) {
    this.state = state >>> 0;
  }

  static fromSeed(seed: number): SeededRng {
    return new SeededRng(seed >>> 0);
  }

  static fromState(state: RngState): SeededRng {
    return new SeededRng(state.seed);
  }

  /** 导出当前可序列化状态。 */
  snapshot(): RngState {
    return { seed: this.state >>> 0 };
  }

  /** 下一个 [0, 2^32) 的无符号整数。 */
  nextUint32(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  }

  /** [0, 1) 的浮点数。 */
  nextFloat(): number {
    return this.nextUint32() / 4294967296;
  }

  /** [minInclusive, maxExclusive) 的整数。 */
  nextInt(minInclusive: number, maxExclusive: number): number {
    if (maxExclusive <= minInclusive) return minInclusive;
    const span = maxExclusive - minInclusive;
    return minInclusive + (this.nextUint32() % span);
  }
}
